<template>
  <div class="pr-sm-3">
    <div
      class="align-center background-color-white d-flex flex-column py-10 px-7 rounded-lg"
    >
      <div class="font-size-lg font-weight-semibold mb-5">Contact Us</div>
      <div class="mb-5 text-center">
        We hope you're enjoying the convenience
        <br />
        of ordering online from {{ wait(storeInfo, "name") }}.
      </div>
      <div class="font-weight-semibold">Contact the Store:</div>
      <div class="mb-5">{{ formatPhoneNumber(wait(storeInfo, "phone")) }}</div>
      <div class="font-weight-semibold">Web Support:</div>
      <div class="mb-5 text-center">
        This web store was created by
        <a
          class="font-weight-semibold"
          href="https://nrsplus.com/"
          target="_blank"
          rel="noreferrer"
          >National Retail Solutions, Inc,</a
        >
        <br />a full-service Point of Sale, payments and retail software
        company.
      </div>
      <div class="text-center">
        For questions or issues with your order, contact the store at the phone
        number above.
      </div>
      <br />
      For technical support, contact:
      <a
        class="font-weight-semibold"
        href="mailto:websitesupport@nrsplus.com"
        rel="noreferrer"
        >websitesupport@nrsplus.com</a
      >
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { formatPhoneNumber, wait } from "@/util.js";

export default {
  name: "SupportDialog",
  computed: {
    ...mapState({
      storeInfo: (state) => state.store.info,
    }),
  },
  methods: {
    formatPhoneNumber,
    wait,
  },
};
</script>
